import React, { useEffect, useMemo, useState } from 'react'
import styled, { css } from 'styled-components'
import Input from 'components/atoms/Input'
import Button from 'components/atoms/Button'
import { changeQuery, getCurrentParsedQuery } from 'utils/navigation'
import { isNotNilOrEmpty } from 'utils/ramda'
import { dissoc, propOr } from 'ramda'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { selectUsersList } from 'modules/users/ducks/selectors'
import { fetchUsersListRoutine } from 'modules/users/ducks/actions'
import { ButtonsWrapper } from 'theme/wrappers'

const emptyValues = {
  created_before: '',
  created_after: '',
  user: 'all'
}

const ChangesHistoryFilters = ({ open }) => {
  const usersList = useSelector(selectUsersList)
  const dispatch = useDispatch()
  const [values, setValues] = useState(emptyValues)
  const {
    location: { search }
  } = useHistory()

  const resetFilters = () => {
    setValues(emptyValues)
    changeQuery({
      page: 1,
      sort: 'name',
      activeTab: 'history_of_changes'
    })
  }

  useEffect(() => {
    const currentQuery = getCurrentParsedQuery()
    dispatch(fetchUsersListRoutine({ query: search }))
    setValues({
      ...emptyValues,
      ...propOr({}, 'filter', currentQuery)
    })
  }, [search])

  const handleValueChange = (name, value) => {
    setValues(prev => ({ ...prev, [name]: value }))
  }

  const usersOptions = useMemo(() => {
    if (isNotNilOrEmpty(usersList)) {
      return [
        { label: 'Wszyscy', value: 'all' },
        ...usersList.map(user => ({
          label: user.username,
          value: user.username
        }))
      ]
    } else {
      return [{ label: 'Wszyscy', value: 'all' }]
    }
  }, [usersList])

  const handleSubmit = () => {
    const currentQuery = getCurrentParsedQuery()
    let payload = {}

    for (let key in values) {
      if (isNotNilOrEmpty(values[key]) && values[key] !== 'all') {
        payload[key] = values[key]
      } else {
        payload = dissoc(key, payload)
      }
    }

    changeQuery({
      ...currentQuery,
      page: 1,
      filter: payload
    })
  }

  return (
    <Wrapper open={open}>
      <Input
        type='date'
        value={values.created_after}
        name='created_after'
        label='Data od'
        onChange={handleValueChange}
        noMarginBottom
      />
      <Input
        type='date'
        value={values.created_before}
        name='created_before'
        label='Data do'
        onChange={handleValueChange}
        noMarginBottom
      />
      <Input
        select
        options={usersOptions}
        value={values.user}
        name='user'
        label='Zmienione przez'
        onChange={handleValueChange}
        noMarginBottom
      />
      <ButtonsWrapper>
        <Button small onClick={handleSubmit} color='primary'>
          Zastosuj
        </Button>
        <Button small onClick={resetFilters} color='primary-outline'>
          Resetuj
        </Button>
      </ButtonsWrapper>
    </Wrapper>
  )
}

export default ChangesHistoryFilters

const Wrapper = styled.div`
  background-color: #fff;
  border-radius: 4px;
  box-shadow: ${({ theme }) => theme.shadows.main};
  width: 100%;
  overflow: hidden;
  height: 0;
  padding: 0 20px;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  gap: 15px;

  ${({ open }) =>
    open &&
    css`
      padding: 20px;
      margin-bottom: 20px;
      height: 110px;
    `}
`
